/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ClientResetPasswordEmailResponse,
  clientResetPassword: (params: vp.ClientResetPasswordEmailRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostClientResetPasswordEmail: ApiHook = ({ api }) => {
  const [shouldClientResetPassword, setShouldClientResetPassword] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.ClientResetPasswordEmailRequest>({
    Username: '',
  });
  const [response, setResponse] = useState<vp.ClientResetPasswordEmailResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldClientResetPassword) return () => {};

    const ChangeUserPassword = async () => {
      setDataFetchingInfo(true, 'sending email', 'fullScreen');
      const res = await api.postClientResetPasswordEmail(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldClientResetPassword) void ChangeUserPassword();
    setShouldClientResetPassword(false);
    return () => {
      source.cancel();
    };
  }, [shouldClientResetPassword]);

  return [
    response,
    (_params: vp.ClientResetPasswordEmailRequest) => {
      setParams(_params);
      setShouldClientResetPassword(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldClientResetPassword(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostClientResetPasswordEmail);
